/*
  tabLOVAS — Favoriler (wishlist)
  12 Ağustos 2026 · temanın orijinali wishlist.YEDEK.js olarak duruyor

  Neden yeniden yazıldı:
  1) KALICILIK — kullanıcı üye olmasa da favorileri bir sonraki ziyarette dursun.
     Artık İKİ yerde birden tutuluyor:
       · localStorage  "shopify-wishlist"   (temanın eski anahtarı — kimse veri kaybetmiyor)
       · çerez         "tablovas_favoriler" (365 gün, path=/, SameSite=Lax)
     Okurken ikisinin BİRLEŞİMİ alınıyor, yazarken ikisine birden yazılıyor.
     Biri temizlenirse diğeri listeyi geri getiriyor.
     Not: ikisi de tarayıcıya/cihaza bağlı. Aynı kişi telefondan ekleyip
     bilgisayardan bakarsa liste boş gelir — bunun için üyelik gerekir.

  2) İKİ ÇÖKME HATASI vardı, ikisi de favoriye her tıklamada tetikleniyordu:
       · `wishlist_item_length` tanımsız değişkeni okunuyordu (ReferenceError)
       · `document.querySelector(".adding")` null dönebiliyordu
     İkisi de giderildi.

  3) Sayaç 0'ken "0" yazan balonu gizliyor ve `lovas:favori-degisti` olayı
     yayınlıyor — başlıktaki kalp sayfa yenilenmeden güncelleniyor.

  GERİ ALMA: wishlist.YEDEK.js dosyasını assets/wishlist.js olarak geri yükle.
*/
class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
    this.COOKIE_KEY = "tablovas_favoriler";
    this.COOKIE_GUN = 365;
    this.LOCAL_STORAGE_DELIMITER = ",";
    this.BUTTON_ACTIVE_CLASS = "active";
    this.addEventListener("click", this.onAddWishlist);
    this.onAddActiveClass();
    WishlistProduct.sayaciGuncelle(this.getWishlist().length);
  }

  /* ---------------- depolama ---------------- */

  cerezOku() {
    const parcalar = document.cookie ? document.cookie.split("; ") : [];
    for (let i = 0; i < parcalar.length; i++) {
      const esit = parcalar[i].indexOf("=");
      if (esit === -1) continue;
      if (parcalar[i].slice(0, esit) !== this.COOKIE_KEY) continue;
      try {
        return decodeURIComponent(parcalar[i].slice(esit + 1));
      } catch (e) {
        return parcalar[i].slice(esit + 1);
      }
    }
    return "";
  }

  cerezYaz(deger) {
    const son = new Date();
    son.setTime(son.getTime() + this.COOKIE_GUN * 24 * 60 * 60 * 1000);
    const govde =
      this.COOKIE_KEY +
      "=" +
      encodeURIComponent(deger) +
      "; expires=" +
      son.toUTCString() +
      "; path=/; SameSite=Lax";
    document.cookie =
      location.protocol === "https:" ? govde + "; Secure" : govde;
  }

  yerelOku() {
    try {
      return localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || "";
    } catch (e) {
      /* gizli sekmede localStorage kapalı olabilir — çerez devrede kalır */
      return "";
    }
  }

  yerelYaz(deger) {
    try {
      if (deger) localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, deger);
      else localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    } catch (e) {
      /* yoksay */
    }
  }

  /* İki kaynağın birleşimi — sıra korunur, tekrar edenler ayıklanır. */
  getWishlist() {
    const ham = (this.yerelOku() + "," + this.cerezOku()).split(
      this.LOCAL_STORAGE_DELIMITER
    );
    const sonuc = [];
    for (let i = 0; i < ham.length; i++) {
      const h = ham[i].trim();
      if (h && sonuc.indexOf(h) === -1) sonuc.push(h);
    }
    return sonuc;
  }

  setWishlist(dizi) {
    const deger = dizi.join(this.LOCAL_STORAGE_DELIMITER);
    this.yerelYaz(deger);
    this.cerezYaz(deger);
    return deger;
  }

  /* İki depo birbirini onarır.
     Örnek: Safari 7 gün sonra localStorage'ı temizler ama çerez durur —
     ya da kullanıcı çerezleri siler, localStorage kalır. Sayfa açılışında
     birleşimi ikisine de geri yazıyoruz ki tek kaynağın kaybı listeyi
     yok etmesin. Silinen ürünü geri getirmez: silme işlemi zaten ikisini
     birden güncellediği için aradaki fark ancak dışarıdan temizlenince oluşur. */
  senkronla() {
    const yerel = this.yerelOku();
    const cerez = this.cerezOku();
    if (yerel === cerez) return;
    const birlesim = this.getWishlist();
    if (birlesim.length) this.setWishlist(birlesim);
    else {
      this.yerelYaz("");
      this.cerezYaz("");
    }
  }

  updateWishlist(handle) {
    const liste = this.getWishlist();
    const yeri = liste.indexOf(handle);
    if (yeri === -1) liste.push(handle);
    else liste.splice(yeri, 1);
    return this.setWishlist(liste);
  }

  wishlistContains(handle) {
    return this.getWishlist().indexOf(handle) !== -1;
  }

  /* ---------------- arayüz ---------------- */

  static sayaciGuncelle(adet) {
    const rozetler = document.querySelectorAll(".wishlist__count");
    for (let i = 0; i < rozetler.length; i++) {
      rozetler[i].innerText = adet;
      /* 0 iken "0" yazan balon görünmesin */
      rozetler[i].style.display = adet > 0 ? "" : "none";
    }
    document.dispatchEvent(
      new CustomEvent("lovas:favori-degisti", { detail: { adet: adet } })
    );
  }

  /* Başlıktaki kalp: sayı değiştiğinde kısa bir zıplama.
     İlk boyamada oynamasın diye önceki değeri saklıyoruz. */
  static basligiOynat() {
    const kalp = document.querySelector(".header__actions_btn--favori");
    if (!kalp) return;
    kalp.classList.remove("lovas-sekme");
    void kalp.offsetWidth;
    kalp.classList.add("lovas-sekme");
    setTimeout(function () {
      kalp.classList.remove("lovas-sekme");
    }, 650);
  }

  WishlistItemCounter() {
    WishlistProduct.sayaciGuncelle(this.getWishlist().length);
  }

  /* Ekran okuyucu etiketi duruma göre değişsin: ekli ürün için
     "Favorilere ekle" demek yanlış olur. */
  static etiketiGuncelle(buton, ekliMi) {
    buton.setAttribute("aria-pressed", ekliMi ? "true" : "false");
    const etiket = ekliMi
      ? buton.dataset.etiketCikar
      : buton.dataset.etiketEkle;
    if (etiket) buton.setAttribute("aria-label", etiket);
  }

  onAddActiveClass() {
    const buton = this.querySelector("button");
    if (!buton) return;
    const handle = buton.dataset.productHandle;
    if (!handle) return;
    const ekli = this.wishlistContains(handle);
    if (ekli) buton.classList.add(this.BUTTON_ACTIVE_CLASS);
    WishlistProduct.etiketiGuncelle(buton, ekli);
  }


  /* ================= SEPETE EKLEME + FAVORİ SAYACI (17 Ağustos 2026) =========
     Kartlardaki kalp içindeki sayı = sepete ekleme + favori (tüm zamanlar).
     Sunucudan Liquid ile basılıyor (data-taban), günlük script tazeliyor.

     Burada iki iş yapılıyor:

     A) FAVORİ OLAYINI GA4'E GÖNDER
        GA4'te wishlist metriği ve kayıtlı özel boyut yok (17.08 doğrulandı),
        bu yüzden ürün kırılımını YERLEŞİK pageLocation boyutuyla taşıyoruz:
        olaya page_location olarak ürünün adresini yazıyoruz. Günlük script
        eventName=add_to_wishlist + pageLocation kırılımında geri okuyor.
        Ürün başına TARAYICI BAŞINA BİR KEZ gönderiliyor — aynı kalbe 50 kez
        basmak sayıyı şişirmesin.

     B) ANINDA +1 GÖSTER
        Kullanıcı favorileyince sayı beklemeden artıyor (gerçekten ekledi).
        Çifte sayma riski şöyle çözüldü: +1 eklerken o anki TABAN değeri
        saklanıyor. Sonraki sayfa açılışında taban büyümüşse (yani günlük
        script o favoriyi zaten saymışsa) yerel +1 düşürülüyor. Zaman damgası
        ya da sunucu senkron saati gerekmiyor, kendi kendini düzeltiyor.
     ========================================================================= */

  static OFSET_ANAHTAR = "lovas_sayac_ofset";
  static GONDERILDI_ANAHTAR = "lovas_fav_gonderildi";

  static jsonOku(anahtar, varsayilan) {
    try {
      return JSON.parse(localStorage.getItem(anahtar)) || varsayilan;
    } catch (e) {
      return varsayilan;
    }
  }

  static jsonYaz(anahtar, deger) {
    try {
      localStorage.setItem(anahtar, JSON.stringify(deger));
    } catch (e) {
      /* gizli sekme — sayaç sunucu değerinde kalır, işlev bozulmaz */
    }
  }

  /* 1.000+ daireye sığmıyor: 2706 -> "2,7B". Liquid tarafındaki biçimlendirmenin
     aynısı; ikisi değişirse birlikte değişmeli. */
  static bicimle(n) {
    if (n < 1000) return String(n);
    var bin = Math.floor(n / 1000);
    var ondalik = Math.floor((n % 1000) / 100);
    return ondalik > 0 ? bin + "," + ondalik + "B" : bin + "B";
  }

  static favoriOlayiGonder(handle) {
    if (typeof window.gtag !== "function") return;
    var gonderildi = WishlistProduct.jsonOku(WishlistProduct.GONDERILDI_ANAHTAR, []);
    if (gonderildi.indexOf(handle) !== -1) return;
    gonderildi.push(handle);
    WishlistProduct.jsonYaz(WishlistProduct.GONDERILDI_ANAHTAR, gonderildi);
    try {
      window.gtag("event", "add_to_wishlist", {
        page_location: window.location.origin + "/products/" + handle,
        items: [{ item_id: handle }]
      });
    } catch (e) {
      /* ölçüm sayacı bozarsa favori işlevi yine çalışsın */
    }
  }

  static rozetYaz(span, deger) {
    span.textContent = WishlistProduct.bicimle(deger);
    span.classList.toggle("lovas-sayac--uzun", deger >= 1000);
  }

  /* Tek ürünün rozetini güncelle (tıklama anında). */
  static rozetGuncelle(handle, ekliMi) {
    var ofset = WishlistProduct.jsonOku(WishlistProduct.OFSET_ANAHTAR, {});
    var secici = '.wishlist__button[data-product-handle="' + handle + '"] .lovas-sayac';
    var spanlar = document.querySelectorAll(secici);
    for (var i = 0; i < spanlar.length; i++) {
      var taban = parseInt(spanlar[i].dataset.taban, 10);
      if (isNaN(taban)) continue;
      WishlistProduct.rozetYaz(spanlar[i], ekliMi ? taban + 1 : taban);
    }
    if (ekliMi) {
      /* İlk spanın tabanını saklıyoruz — hepsi aynı üründen geliyor. */
      var ilk = spanlar[0];
      if (ilk) ofset[handle] = parseInt(ilk.dataset.taban, 10);
    } else {
      delete ofset[handle];
    }
    WishlistProduct.jsonYaz(WishlistProduct.OFSET_ANAHTAR, ofset);
  }

  /* Sayfa açılışında saklanan +1'leri uygula, eskiyenleri düşür. */
  static rozetleriTazele(liste) {
    var ofset = WishlistProduct.jsonOku(WishlistProduct.OFSET_ANAHTAR, {});
    var degisti = false;
    var spanlar = document.querySelectorAll(".wishlist__button .lovas-sayac");
    for (var i = 0; i < spanlar.length; i++) {
      var span = spanlar[i];
      var buton = span.closest(".wishlist__button");
      if (!buton) continue;
      var handle = buton.dataset.productHandle;
      var taban = parseInt(span.dataset.taban, 10);
      if (!handle || isNaN(taban)) continue;

      var saklanan = ofset[handle];
      var favoride = liste.indexOf(handle) !== -1;

      /* Taban saklanan değeri geçtiyse günlük script bu favoriyi zaten
         saymış demektir; yerel +1 düşer. Favoriden çıkarılmışsa da düşer. */
      if (saklanan == null || !favoride || taban > saklanan) {
        if (saklanan != null) {
          delete ofset[handle];
          degisti = true;
        }
        WishlistProduct.rozetYaz(span, taban);
      } else {
        WishlistProduct.rozetYaz(span, taban + 1);
      }
    }
    if (degisti) WishlistProduct.jsonYaz(WishlistProduct.OFSET_ANAHTAR, ofset);
  }

  onAddWishlist() {
    const buton = this.querySelector("button");
    if (!buton) return;
    const handle = buton.dataset.productHandle;
    if (!handle) {
      console.error("[Favoriler] data-product-handle yok, liste güncellenmedi.");
      return;
    }

    this.updateWishlist(handle);
    const kalanAdet = this.getWishlist().length;
    WishlistProduct.sayaciGuncelle(kalanAdet);

    /* Sayaç: favorilendiyse GA4'e bir kez bildir, rozeti anında güncelle.
       Favoriler sayfasındaki erken çıkıştan ÖNCE yapılıyor ki oradan
       çıkarılan ürünün ofseti de temizlensin. */
    const sayacEkliMi = this.wishlistContains(handle);
    if (sayacEkliMi) WishlistProduct.favoriOlayiGonder(handle);
    WishlistProduct.rozetGuncelle(handle, sayacEkliMi);

    const izgara = document.querySelector("[grid-wishlist]");

    /* Favoriler sayfasındaysak kartı listeden çıkar. */
    if (izgara) {
      const kart = this.closest(".product__card");
      const kap = kart ? kart.parentElement : null;
      if (kart) kart.remove();
      if (kap && kap.classList.contains("col")) kap.remove();
      if (kalanAdet <= 0) {
        const sayfa = document.querySelector(".wishlist-page");
        if (sayfa) sayfa.classList.remove("wishlist_exists");
      }
      return;
    }

    /* Normal kart: kalbi ANINDA doldur/boşalt + pop animasyonu.
       Temanın 500ms'lik "loading" spinner'ı kaldırıldı: işlem yerelde
       anında bittiği için bekleme göstergesi yanıltıcıydı. */
    const ekliMi = this.wishlistContains(handle);
    buton.classList.toggle("active", ekliMi);
    WishlistProduct.etiketiGuncelle(buton, ekliMi);

    buton.classList.remove("lovas-pop");
    void buton.offsetWidth; /* reflow — animasyon üst üste tıklamada yeniden oynasın */
    buton.classList.add("lovas-pop");
    setTimeout(function () {
      buton.classList.remove("lovas-pop");
    }, 600);
  }
}

customElements.define("wishlist-item", WishlistProduct);

const newWishlistObj = new WishlistProduct();
newWishlistObj.senkronla();

/* Sayfadaki her kalp yüklendikten sonra sayaç bir kez daha tazelensin
   (başlıktaki rozet, kartlardan önce basılmış olabiliyor). */
document.addEventListener("DOMContentLoaded", function () {
  newWishlistObj.senkronla();
  WishlistProduct.sayaciGuncelle(newWishlistObj.getWishlist().length);
  WishlistProduct.rozetleriTazele(newWishlistObj.getWishlist());

  const izgara = document.querySelector("[grid-wishlist]");
  if (izgara) setupGrid(izgara);
});

/* ---------------- Favoriler sayfası: boyut seçimi + fiyat ---------------- */

/* Kartlar sayfa yüklendikten SONRA fetch ile geliyor; bu yüzden
   doğrudan dinleyici değil, document üzerinde delegasyon kullanılıyor. */
document.addEventListener("click", function (e) {
  const chip =
    e.target && e.target.closest ? e.target.closest(".lovas-fav__boyut") : null;
  if (!chip || chip.disabled) return;

  const blok = chip.closest("[data-lovas-fav]");
  if (!blok) return;

  blok.querySelectorAll(".lovas-fav__boyut").forEach(function (d) {
    const secili = d === chip;
    d.classList.toggle("secili", secili);
    d.setAttribute("aria-checked", secili ? "true" : "false");
  });

  const vid = chip.dataset.lovasVid;
  const gizli = blok.querySelector("[data-lovas-vid-input]");
  if (gizli) gizli.value = vid;

  let veri = [];
  try {
    veri = JSON.parse(
      blok.querySelector("[data-lovas-varyantlar]").textContent
    );
  } catch (err) {
    return;
  }
  const v = veri.find(function (x) {
    return String(x.id) === String(vid);
  });
  if (!v) return;

  const yeni = blok.querySelector("[data-lovas-yeni]");
  const eski = blok.querySelector("[data-lovas-eski]");
  if (yeni) yeni.textContent = v.fiyat;
  if (eski) {
    if (v.eski) {
      eski.textContent = v.eski;
      eski.hidden = false;
    } else {
      eski.textContent = "";
      eski.hidden = true;
    }
  }

  const ekle = blok.querySelector(".lovas-fav__ekle");
  if (ekle) {
    ekle.disabled = !v.stok;
    const metin = ekle.querySelector("[data-lovas-ekle-metin]");
    if (metin && !v.stok) metin.textContent = "Tükendi";
  }

  /* fiyat değişti — küçük bir vurgu */
  const fiyatKutusu = blok.querySelector(".lovas-fav__fiyat");
  if (fiyatKutusu) {
    fiyatKutusu.classList.remove("lovas-fiyat-degisti");
    void fiyatKutusu.offsetWidth;
    fiyatKutusu.classList.add("lovas-fiyat-degisti");
  }
});

var setupGrid = function (izgara) {
  const liste = newWishlistObj.getWishlist();
  const sayfa = document.querySelector(".wishlist-page");

  if (!liste.length) {
    izgara.innerHTML = "";
    return;
  }
  if (sayfa) sayfa.classList.add("wishlist_exists");

  const istekler = liste.map(function (handle) {
    return fetch("/products/" + handle + "?view=wishlist")
      .then(function (res) {
        return res.status === 200 ? res.text() : "";
      })
      .catch(function () {
        /* Silinmiş/erişilemeyen ürün listeyi çökertmesin. */
        return "";
      });
  });

  Promise.all(istekler).then(function (cevaplar) {
    const html = cevaplar.join("");
    izgara.innerHTML = html;
    if (!html.trim() && sayfa) sayfa.classList.remove("wishlist_exists");
  });
};

/* Sayı her değiştiğinde başlıktaki kalp kısa bir zıplar.
   Sayfa ilk boyandığında oynamaması için ilk değer atlanıyor. */
(function () {
  let sonAdet = null;
  document.addEventListener("lovas:favori-degisti", function (e) {
    const adet = e.detail ? e.detail.adet : 0;
    if (sonAdet !== null && adet !== sonAdet) WishlistProduct.basligiOynat();
    sonAdet = adet;
  });
})();

/* ---------------- Favoriler: 1 / 2 sütun seçici ----------------
   Varsayılan tek sütun (büyük görsel). Seçim localStorage'da kalıcı. */
(function () {
  var ANAHTAR = "lovas_favori_gorunum";

  function tercihOku() {
    try {
      var d = localStorage.getItem(ANAHTAR);
      return d === "ikili" ? "ikili" : "tek";
    } catch (e) {
      return "tek";
    }
  }

  function uygula(deger) {
    var izgara = document.querySelector("[grid-wishlist]");
    if (izgara) izgara.setAttribute("data-gorunum", deger);
    var butonlar = document.querySelectorAll("[data-lovas-gorunum] .lovas-gorunum__btn");
    for (var i = 0; i < butonlar.length; i++) {
      var secili = butonlar[i].getAttribute("data-gorunum") === deger;
      butonlar[i].classList.toggle("secili", secili);
      butonlar[i].setAttribute("aria-pressed", secili ? "true" : "false");
    }
  }

  document.addEventListener("click", function (e) {
    var btn =
      e.target && e.target.closest
        ? e.target.closest("[data-lovas-gorunum] .lovas-gorunum__btn")
        : null;
    if (!btn) return;
    var deger = btn.getAttribute("data-gorunum") === "ikili" ? "ikili" : "tek";
    try {
      localStorage.setItem(ANAHTAR, deger);
    } catch (err) {
      /* yoksay */
    }
    uygula(deger);
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[grid-wishlist]")) uygula(tercihOku());
  });
})();
